import styled from 'styled-components';
import { lightTheme as theme } from '../../../shared/theme';

export const PageRoot = styled.div`
    min-height: 80vh;
    background: linear-gradient(180deg, ${theme.colors.background} 0%, ${theme.colors.gray100} 100%);
`;

export const HomeContent = styled.div`
    margin: 0 auto;
    max-width: 1200px;
    padding: 24px 32px;

    @media (max-width: 768px) {
        padding: 16px;
    }
`;

export const HomeTitle = styled.h1`
    margin: 0 0 20px;
    color: ${theme.colors.text};
    font-size: clamp(1.5rem, 1.2rem + 1vw, 2rem);
    font-weight: 700;
    letter-spacing: -0.01em;
`;

export const CardsGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
    gap: 24px;

    @media (max-width: 768px) {
        grid-template-columns: 1fr;
        gap: 12px;
    }
`;

export const ActionCard = styled.a`
    min-height: 180px;
    text-decoration: none;
    border-radius: 12px;
    border: 1px solid ${theme.colors.primaryLight};
    background: linear-gradient(135deg, ${theme.colors.primary} 0%, ${theme.colors.primaryLight} 100%);
    color: ${theme.colors.paper};
    box-shadow: ${theme.colors.shadowSm};
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    gap: 14px;
    padding: 20px;
    transition: transform 0.2s ease, box-shadow 0.2s ease, filter 0.2s ease;

    &:hover,
    &:focus {
        text-decoration: none;
        color: ${theme.colors.paper};
        transform: translateY(-2px);
        box-shadow: ${theme.colors.shadowMd};
        filter: brightness(1.04);
    }
`;

export const CardIconWrap = styled.span`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: ${theme.colors.paper};

    svg {
        font-size: 1.7rem;
    }
`;

export const CardLabel = styled.span`
    font-size: 1.15rem;
    line-height: 1.4;
    font-weight: 600;
    color: ${theme.colors.paper};
`;
